import React, { useState } from 'react';
import makeStyles from '@material-ui/styles/makeStyles';
import classnames from 'classnames';
import Typography from '@material-ui/core/Typography';
import useWindowSize from '../../hooks/useWindowSize';
import { GatsbyImage, getImage, IGatsbyImageData } from 'gatsby-plugin-image';
import { useTranslation } from 'gatsby-plugin-react-i18next';

const phoneSizes = {
  mobile: {
    inactive: {
      w: 178,
      h: 378,
    },
    active: {
      w: 209,
      h: 453,
    },
    gap: 32,
  },
  desktop: {
    inactive: {
      w: 200,
      h: 424,
    },
    active: {
      w: 245,
      h: 530,
    },
    gap: 40,
  }
}

const useStyles = makeStyles(theme => {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    carouselContainer: {
      width: phoneSizes.mobile.active.w * 2,
      display: 'flex',
      marginBottom: 45,
      [theme.breakpoints.up(1200)]: {
        width: phoneSizes.desktop.active.w * 2,
      },
    },
    carousel: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: phoneSizes.mobile.gap,
      [theme.breakpoints.up(1200)]: {
        gap: phoneSizes.desktop.gap,
      },
    },
    slide: {
    },
    activeSlide: {
    },
    phone: {
      display: 'block',
      width: phoneSizes.mobile.inactive.w,
      height: phoneSizes.mobile.inactive.h,
      borderRadius: '26px',
      border: '4px solid #fff',
      boxShadow: '-10px 10px 30px rgba(0, 0, 0, 0.15)',
      transform: 'translateZ(0)',
      [theme.breakpoints.up(1200)]: {
        width: phoneSizes.desktop.inactive.w,
        height: phoneSizes.desktop.inactive.h,
      },
    },
    phoneActive: {
      display: 'block',
      width: phoneSizes.mobile.active.w,
      height: phoneSizes.mobile.active.h,
      borderRadius: '26px',
      border: '4px solid #fff',
      boxShadow: '-10px 10px 30px rgba(0, 0, 0, 0.15)',
      transform: 'translateZ(0)',
      [theme.breakpoints.up(1200)]: {
        width: phoneSizes.desktop.active.w,
        height: phoneSizes.desktop.active.h,
      },
    },
    textContainer: {
      textAlign: 'center',
      '& h3': {
        color: theme.palette.primary.main,
        fontSize: 24,
        lineHeight: '30px',
        fontWeight: 700,
        letterSpacing: -0.5,
        marginBottom: 24,
      },
      '& p': {
        fontSize: 17,
        lineHeight: '24px',
        margin: '0 auto',
      },
      [theme.breakpoints.up(1200)]: {
        '& p': {
          maxWidth: 451,
        },
      },
    },
  };
});

const PhoneCarousel = ({ items = [] }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [selectedIndex, setSelectedIndex] = useState(2);

  const { width: screenWidth } = useWindowSize();
  let phoneSize = phoneSizes.mobile.active.w;
  if (screenWidth >= 1200) {
    phoneSize = phoneSizes.desktop.active.w;
  }
  const offset = selectedIndex * phoneSize - 0.5 * phoneSize;
  // const currentPhone = items[selectedIndex];

  return (
    <div className={classes.root}>
      <div className={classes.carouselContainer}>
        <div
          className={classes.carousel}
          style={{
            transform: `translate(${-offset}px)`,
            transition: 'transform 0.5s',
          }}
        >
          {items.map((phone, index) => {
            const image = getImage(phone.image);
            return (
              <div
                key={phone.title.text}
                className={classnames(classes.slide, selectedIndex === index ? classes.activeSlide : undefined)}
                onClick={() => {
                  setSelectedIndex(index);
                }}
                onKeyDown={() => {
                  setSelectedIndex(index);
                }}
                role="button"
                tabIndex={0}
              >
                <GatsbyImage
                  className={selectedIndex === index ? classes.phoneActive : classes.phone}
                  image={(image as IGatsbyImageData)}
                  alt={phone.image.alt || ''}
                />
              </div>
            );
          })}
        </div>
      </div>
      <div className={classes.textContainer}>
        <Typography variant="h3">{t(`landingPage.screenshots.${selectedIndex + 1}.title`)}</Typography>
        <Typography variant="body1">{t(`landingPage.screenshots.${selectedIndex + 1}.text`)}</Typography>
      </div>
    </div>
  );
};

export default PhoneCarousel;
